<div *ngFor="let section of reviewItemSections" class="review-item-section">
  <h3 class="review-item-section-header">{{ section.header }}</h3>
  <ul class="review-item-section-list">
    <li *ngFor="let item of section.items" class="review-item-section-item">
      {{ item | phoneNumber }}
    </li>
  </ul>
</div>
